import { Card } from "antd";
import {
  ClipboardCheck,
  Calendar,
  Trophy,
} from "lucide-react";

const statsData = [
  {
    id: 1,
    label: "Hours Worked",
    value: "152.5 hrs",
    sub: "This Month",
    icon: <ClipboardCheck className="w-4 h-4" />,
  },
  {
    id: 2,
    label: "Days Present",
    value: "19/22",
    sub: "86.4% Attendance",
    icon: <Calendar className="w-4 h-4" />,
  },
  {
    id: 3,
    label: "Avg. Hours/Day",
    value: "8.2 hrs",
    sub: "Expected: 8 hrs",
    icon: <ClipboardCheck className="w-4 h-4" />,
  },
  {
    id: 4,
    label: "On-Time %",
    value: "94.7%",
    sub: "18/19 days",
    icon: <Trophy className="w-4 h-4" />,
  },
];

export default function WorkSummaryCard() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((item) => (
        <Card
          key={item.id}
          className={`flex flex-col gap-6 rounded-xl card-border-s ${
            item.label
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-") 
              .replace(/^-+|-+$/g, "")
          }`}

          bodyStyle={{ padding: 16 }}
        >
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs">
              {item.label}
            </p>
            <div className="card-text">{item.icon}</div>
          </div>

          <p className="text-2xl font-bold card-text">{item.value}</p>

          <p className="text-xs text-muted-foreground dark:text-zinc-500 mt-1">
            {item.sub}
          </p>
        </Card>
      ))}
    </div>
  );
}
